<div class="page-header">
  <app-page-title></app-page-title>
</div>

<div class="mock-shell">
  <section class="workspace-grid">
    <div class="workspace-main">

      <div class="list-filter-bar">
        <div class="filter-bar-row">
          <div class="filter-search-wrap">
            <i class="bi bi-search filter-search-icon"></i>
            <input type="text"
                   class="form-control filter-search-input"
                   placeholder="ค้นหาสินค้า, ฟาร์ม, เลขที่ใบรับรอง, ผู้ประกอบการ…"
                   [ngModel]="searchTerm()"
                   (ngModelChange)="onSearchTermChange($event)">
          </div>
          <button type="button" class="btn-refresh" (click)="reload()" [disabled]="isLoading()">
            <i class="bi bi-arrow-clockwise"></i> รีเฟรช
          </button>
        </div>
      </div>

      <div class="role-tabs-bar">
        @for (tab of statusTabs; track tab.value) {
          <button type="button"
                  class="role-tab"
                  [class.active]="activeStatus() === tab.value"
                  (click)="selectStatus(tab.value)">
            {{ tab.label }}
            @if (tab.value === 'PENDING' && pendingCount() > 0) {
              <span class="tab-count">{{ pendingCount() }}</span>
            }
          </button>
        }
      </div>

      @if (isLoading()) {
        <div class="list-empty">กำลังโหลดข้อมูล…</div>
      } @else if (filteredItems().length === 0) {
        <div class="list-empty">ไม่พบคำขอยืนยันการจำหน่าย</div>
      } @else {
        <div class="record-list">
          @for (item of filteredItems(); track item.id) {
            <div class="record-card">
              <div class="rc-content-col">
                <div class="rc-top-line">
                  <div class="rc-applicant">{{ item.applicantName || 'ไม่ระบุผู้ประกอบการ' }}</div>
                  <div class="rc-requested-at">
                    วันที่สอบถาม: {{ item.requestedAt ? (item.requestedAt | thaidatetime) : '-' }}
                  </div>
                </div>
                <div class="rc-middle-line">
                  <div class="rc-product-wrap">
                    <span class="rc-product">{{ item.materialName || 'ไม่ระบุสินค้า' }}</span>
                    <span [class]="'rc-status ' + statusClass(item.status)">
                      @if (item.status === 'CONFIRMED') {
                        <i class="bi bi-patch-check-fill"></i>
                      }
                      {{ statusLabel(item.status) }}
                    </span>
                  </div>
                  <div class="rc-actions">
                    @if (isPending(item)) {
                      <button type="button"
                              class="btn-confirm"
                              [disabled]="decidingId() !== null"
                              (click)="onConfirm(item)">ยืนยัน
                      </button>
                      @if (rejectingId() !== item.id) {
                        <button type="button"
                                class="btn-reject"
                                [disabled]="decidingId() !== null"
                                (click)="startReject(item)">ไม่ยืนยัน
                        </button>
                      }
                    } @else if (item.decidedAt) {
                      <span class="rc-decided-at">วันที่ดำเนินการ: {{ item.decidedAt | thaidatetime }}</span>
                    }
                  </div>
                </div>
                <div class="rc-bottom-line">
                  <span class="rc-farm-lot">ฟาร์ม {{ item.plantationName || '-' }}</span>
                  @if (item.plantationNo) {
                    <span class="rc-meta-dot">•</span>
                    <span>หมายเลขแปลง {{ item.plantationNo }}</span>
                  }
                  @if (item.certificateNo) {
                    <span class="rc-meta-dot">•</span>
                    <span class="rc-cert">ใบรับรองเลขที่ {{ item.certificateNo }}</span>
                  }
                  @if (item.certificateSubName) {
                    <span class="rc-cert-sub">{{ item.certificateSubName }}</span>
                  }
                </div>
                @if (item.remark) {
                  <div class="rc-remark">หมายเหตุ {{ item.remark }}</div>
                }
                @if (rejectingId() === item.id) {
                  <div class="rc-reject-box">
                    <textarea class="form-control rc-reject-remark"
                              rows="2"
                              maxlength="1024"
                              placeholder="หมายเหตุ (ไม่บังคับ)"
                              [ngModel]="rejectRemark()"
                              (ngModelChange)="rejectRemark.set($event)"></textarea>
                    <div class="rc-reject-actions">
                      <button type="button"
                              class="btn-reject"
                              [disabled]="decidingId() !== null"
                              (click)="confirmReject(item)">ยืนยันการไม่ยืนยัน
                      </button>
                      <button type="button" class="btn-cancel" (click)="cancelReject()">ยกเลิก</button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }

    </div>
  </section>
</div>
